import { render } from "./PopupLostPassword.vue?vue&type=template&id=5f15aa84"
import script from "./PopupLostPassword.vue?vue&type=script&lang=js"
export * from "./PopupLostPassword.vue?vue&type=script&lang=js"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__